import api from "@helpers/api";

import { URLS } from "@constants/urls";

import {
  selectedGroups,
  selectedPermissions,
} from "@helpers/positionSwitchDataConverter";

import { PositionCreateType, PositionType } from "@type/HRM/position";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.UNIT_POSITIONS}`;

export const createPosition = (() => {
  return async (data: {
    data: PositionCreateType;
  }): Promise<{ data: PositionType }> => {
    const {
      designation,
      isHead,
      isDeleted,
      isHired,
      wing,
      groups,
      permissions,
      postType,
    } = data.data;

    return api
      .post(`${apiEndPoint}`, {
        positionId: designation,
        unitId: wing,
        isHead: isHead,
        isHired: isHired,
        isDeleted: isDeleted,
        groupIds: selectedGroups(groups),
        permissionIds: selectedPermissions(permissions),
        postType: postType,
      })
      .then((response) => ({ data: response.data }));
  };
})();

export const getPosition = (() => {
  return async (data: { data: number }): Promise<{ data: PositionType }> => {
    const { data: id } = data;

    return api
      .get(`${apiEndPoint}/${id}`)
      .then((response) => ({ data: response.data }));
  };
})();

export const updatePosition = (() => {
  return async (data: {
    data: PositionType;
  }): Promise<{ data: PositionType }> => {
    const {
      id,
      designation,
      isHead,
      isHired,
      isDeleted,
      wing,
      groups,
      permissions,
      postType,
    } = data.data;

    return api
      .put(`${apiEndPoint}/${id}`, {
        id: Number(id),
        isHead: isHead,
        isHired: isHired,
        isDeleted: isDeleted,
        positionId: designation,
        unitId: wing,
        groupIds: selectedGroups(groups),
        permissionIds: selectedPermissions(permissions),
        postType: postType,
      })
      .then((response) => ({ data: response.data }));
  };
})();
